// @flow

import _ from 'lodash/fp';
import React from 'react';
import {NotificationStack} from 'react-notification';
import './Notifications.css';

export type Props = {
  removeNotification: Function,
  notifications: any[],
};

const Notifications = ({removeNotification, notifications}: Props) => (
  <div className="Notifications">
    <NotificationStack
      notifications={_.map(n => ({
        message: n.message,
        key: n.id,
        action: <i className="fa fa-close" />,
        dismissAfter: 2000,
        style: false,
        className: n.level,
        onClick: () => removeNotification(n.id),
      }), notifications)}
      onDismiss={n => removeNotification(n.key)} />
  </div>
);

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.js